import React from 'react';
import IconButton from '@material-ui/core/IconButton';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import CxTooltip from './CxTooltip';

export default function CxIconButtonNew(props) {
  const { xref, onClick, onMouseDown, onMouseUp, classType, data, ...rest } = props;

  const [state, setState] = React.useState(rest.state || 'OFF');
  const [icon, setIcon] = React.useState(rest.icon);
  const [icon_ori] = React.useState(rest.icon);
  const [icon_alt] = React.useState(rest.icon_alt);
  const [visible, setVisible] = React.useState(rest.visible === 'false' ? false : true);
  const [disabled, setDisabled] = React.useState(rest.disabled);

  React.useEffect(() => setDisabled(rest.disabled), [rest.disabled]);

  React.useImperativeHandle(xref, () => {
    return {
      getState, setIcon, setDisabled, setVisible
    };
  });

  const getState = () => { return state };

  // --- MANEJADORES DE EVENTOS MEJORADOS PARA MÓVIL ---

  const doClick = (event) => {
    if (state === 'ON') {
      setState('OFF');
      if (icon_alt) setIcon(icon_ori);
    } else {
      setState('ON');
      if (icon_alt) setIcon(icon_alt);
    }

    if (onClick) {
      onClick(data || event);
    }
  };

  const handleStart = (event) => {
    // Evitamos comportamientos extraños del navegador
    if (onMouseDown) {
      onMouseDown(data || event);
    }
  };

  const handleEnd = (event) => {
    if (onMouseUp) {
      onMouseUp(data || event);
    }
  };

  const preventLongPressMenu = (event) => {
    // Esta es la clave: evita que el móvil abra el menú de selección de texto
    // al mantener pulsado el botón de voz.
    event.preventDefault();
  };

  return (
    <div style={{ display: visible ? '' : 'none' }}>
      <CxTooltip text={rest.tooltip ? rest.tooltip : null}>
        {/* Usamos un span contenedor para neutralizar eventos de selección de texto */}
        <span 
          onContextMenu={preventLongPressMenu}
          style={{ 
            WebkitTouchCallout: 'none', 
            WebkitUserSelect: 'none', 
            userSelect: 'none' 
          }}
        >
          <IconButton 
            className={classType ? classType : "ibs_iconbutton"} 
            // Eventos de Ratón (Escritorio)
            onMouseDown={handleStart}
            onMouseUp={handleEnd}
            // Eventos Táctiles (Móvil)
            onTouchStart={handleStart}
            onTouchEnd={handleEnd}
            onClick={doClick} 
            disabled={disabled} 
            tabIndex={-1} 
            {...rest}
            style={{ 
              ...rest.style,
              touchAction: 'none', // Evita scroll/zoom mientras se mantiene pulsado
            }}
          >
            {icon}
          </IconButton>
        </span>
      </CxTooltip>
    </div>
  );
}